import React from 'react';
import MainMenu from "./main_menu";
import AppBar from '@material-ui/core/AppBar';
import CssBaseline from '@material-ui/core/CssBaseline';
import Divider from '@material-ui/core/Divider';
import Drawer from '@material-ui/core/Drawer';
import Hidden from '@material-ui/core/Hidden';
import IconButton from '@material-ui/core/IconButton';
// import Notifications from '@material-ui/icons/Notifications';
import ExitToApp from '@material-ui/icons/ExitToApp';
import MenuIcon from '@material-ui/icons/Menu';
import Toolbar from '@material-ui/core/Toolbar';
import Typography from '@material-ui/core/Typography';
import {withStyles} from '@material-ui/core/styles';
import Grid from '@material-ui/core/Grid';
import LoadingProcess from "../simple/loading_process";
import {bindActionCreators , compose} from "redux";
import {connect} from "react-redux";
import {logout} from '@componentDP/js_react/redux/actions/login';
import {cloneDeep} from 'lodash';
import LanguageSwitcher from './LanguageSwitcher';
import {withTranslation} from "react-i18next";

const drawerWidth = 240;

const styles = theme => ({
    themeDirection: theme.direction,
    root: {
        display: 'flex',
    },
    drawer: {
        [theme.breakpoints.up('sm')]: {
            width: drawerWidth,
            flexShrink: 0,
        },
    },
    appBar: {
        [theme.breakpoints.up('sm')]: {
            width: `calc(100% - ${drawerWidth}px)`,
            marginLeft: drawerWidth,
        },
        backgroundColor: '#009be5',
    },
    menuButton: {
        marginRight: theme.spacing(2),
        [theme.breakpoints.up('sm')]: {
            display: 'none',
        },
    },
    // necessary for content to be below app bar
    toolbar: theme.mixins.toolbar,
    drawerPaper: {
        width: drawerWidth,
        backgroundColor: '#18202c',
    },
    content: {
        flexGrow: 1,
        padding: theme.spacing(3),
        marginTop: '40px',
    },
    header: {
        marginTop: '10px',
    },
    notification: {
        textAlign: 'right',
        marginTop: '10px',
    },
    menuHeader: {
        color: '#fff',
        paddingTop: '10px',
        paddingBottom: '10px',
        backgroundColor: '#232f3e',
    },
    divider: {
        backgroundColor: '#404854',
    },
    colorWhite: {
        color: '#fff',
    },
    btnLogout: {
        paddingTop: '0',
        paddingBottom: '0',
    },
});

class PageTemplate extends React.Component {
    constructor(props) {
        super(props);
        this.state = {
            mobileOpen: false,
        };
        this.handleDrawerToggle = this.handleDrawerToggle.bind(this);
        this.handleLogout = this.handleLogout.bind(this);
    }
    handleDrawerToggle = () => {
        const {mobileOpen} = this.state;
        this.setState({mobileOpen: !mobileOpen})
    };
    handleLogout = () => {
        const {logout} = this.props;
        logout();
    };
    render() {
        const {handleDrawerToggle, handleLogout} = this;
        const {classes, window, children, title, vuzName, digitalProfileSettings} = this.props;
        const {mobileOpen} = this.state;
        const { t } = this.props;
        const drawer = (
            <div>
                <div className={classes.toolbar}>
                    <Typography variant="h6" align={"center"} className={classes.menuHeader}>
                        {t('lk_abitur')}
                        <div>
                            <LanguageSwitcher />
                        </div>
                    </Typography>
                </div>
                <Divider className={classes.divider} />
                <MainMenu digitalProfileSettings={digitalProfileSettings} />
                <Divider />
            </div>
        );

        const container = window !== undefined ? () => window().document.body : undefined;

        return (
            <div className={classes.root}>
                <CssBaseline />
                <AppBar position="fixed" className={classes.appBar}>
                    <Toolbar className={classes.header}>
                        <Grid container spacing={2}>
                            <Grid item xs={12}>
                                <Grid container spacing={1}>
                                    <Grid item xs={10}>
                                        <IconButton
                                            color="inherit"
                                            aria-label="open drawer"
                                            edge="start"
                                            onClick={handleDrawerToggle}
                                            className={classes.menuButton}
                                        >
                                            <MenuIcon />
                                        </IconButton>
                                        <Hidden xsDown>
                                            <Typography variant="h5">
                                                {vuzName}
                                            </Typography>
                                        </Hidden>
                                    </Grid>
                                    <Grid item xs={2} className={classes.notification}>
                                        {/*<Notifications />*/}
                                        <IconButton aria-label="exit" title={t('exit')} onClick={handleLogout} className={classes.btnLogout}>
                                            <ExitToApp className={classes.colorWhite} />
                                        </IconButton>
                                    </Grid>
                                </Grid>
                                <Grid container spacing={0}>
                                    <Grid item xs={12}>
                                        <Typography variant="h6" noWrap>
                                            {title}
                                        </Typography>
                                    </Grid>
                                </Grid>
                            </Grid>
                        </Grid>
                    </Toolbar>
                </AppBar>
                <nav className={classes.drawer} aria-label="mailbox folders">
                    {/* The implementation can be swapped with js to avoid SEO duplication of links. */}
                    <Hidden smUp implementation="css">
                        <Drawer
                            container={container}
                            variant="temporary"
                            anchor={classes.themeDirection === 'rtl' ? 'right' : 'left'}
                            open={mobileOpen}
                            onClose={handleDrawerToggle}
                            classes={{
                                paper: classes.drawerPaper,
                            }}
                            ModalProps={{
                                keepMounted: true, // Better open performance on mobile.
                            }}
                        >
                            {drawer}
                        </Drawer>
                    </Hidden>
                    <Hidden xsDown implementation="css">
                        <Drawer
                            classes={{
                                paper: classes.drawerPaper,
                            }}
                            variant="permanent"
                            open
                        >
                            {drawer}
                        </Drawer>
                    </Hidden>
                </nav>
                <main className={classes.content}>
                    <div className={classes.toolbar} />
                    {children}
                    <LoadingProcess />
                </main>
            </div>
        );
    }
}

function mapStateToProps(state) {
    return {
        vuzName: cloneDeep(state.vuzName),
        digitalProfileSettings: cloneDeep(state.digitalProfileSettings),
    };
}

function mapDispatchToProps(dispatch) {
    return bindActionCreators({
        logout,
    }, dispatch);
}

export default compose(withStyles(styles), connect(mapStateToProps, mapDispatchToProps))(withTranslation()(PageTemplate));
